import { useEffect } from 'react'
import { Link, Navigate, useParams } from 'react-router-dom'
import MarketingLayout from '../marketing/MarketingLayout'
import Seo from '../marketing/Seo'
import StoreBadges from '../marketing/StoreBadges'
import BLOG_POSTS, { getBlogPostBySlug } from './blogPosts'
import '../AppLandingPage.css'
import '../marketing/Marketing.css'

/** Template for /blog/:slug — renders one article from blogPosts.js. */
export default function BlogPost() {
    const { slug } = useParams()
    const post = getBlogPostBySlug(slug)

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [slug])

    if (!post) {
        return <Navigate to="/blog" replace />
    }

    const otherPosts = BLOG_POSTS.filter((other) => other.slug !== post.slug).slice(0, 3)

    const articleJsonLd = {
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        headline: post.title,
        description: post.seoDescription,
        datePublished: post.date,
        author: { '@type': 'Organization', name: 'First Dance' },
        publisher: { '@type': 'Organization', name: 'First Dance', url: 'https://firstdance.app' },
        mainEntityOfPage: `https://firstdance.app/blog/${post.slug}`,
    }

    return (
        <MarketingLayout>
            <Seo
                title={post.seoTitle}
                description={post.seoDescription}
                path={`/blog/${post.slug}`}
            />
            <script type="application/ld+json">{JSON.stringify(articleJsonLd)}</script>

            <div className="marketing-page">
                <div className="marketing-hero">
                    <p className="marketing-breadcrumb">
                        <Link to="/">Home</Link> &rsaquo; <Link to="/blog">Blog</Link> &rsaquo; {post.title}
                    </p>
                    <h1>{post.title}</h1>
                    <p className="blog-meta">
                        {post.dateLabel} &middot; {post.readTime}
                    </p>
                </div>
                <div className="hero-divider" />

                <article className="blog-article">
                    <img src={post.image} alt={post.imageAlt} className="blog-article-hero-image" />

                    <p className="blog-article-intro">{post.intro}</p>

                    {post.sections.map((section) => (
                        <section key={section.heading}>
                            <h2>{section.heading}</h2>
                            {section.body}
                        </section>
                    ))}
                </article>

                <div className="marketing-cta-band">
                    <h2>{post.cta.heading}</h2>
                    <p>{post.cta.text}</p>
                    <StoreBadges />
                </div>

                <section className="marketing-section">
                    <div className="marketing-container">
                        <h2>Keep reading</h2>
                        <div className="related-features">
                            {otherPosts.map((other) => (
                                <Link
                                    key={other.slug}
                                    className="related-feature-link"
                                    to={`/blog/${other.slug}`}
                                >
                                    {other.title}
                                </Link>
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        </MarketingLayout>
    )
}
